import { oliveBorderTokens } from '@ds/tokens'

const tokens = {
  defaultColor: oliveBorderTokens.borderColorDefault,
  emphasisColor: oliveBorderTokens.borderColorEmphasis,
  subtleColor: oliveBorderTokens.borderColorSubtle,
} as const

export default tokens
